export type AssistantJobCompletedTurnRequest = {
  query: string;
  model_id?: string | null;
};

export type AssistantJobCompletedTurnResponse = {
  output: string;
  figure?: Record<string, Record<string, unknown>>;
  used_tools?: string[];
  queried_model_id?: string;
  next_model_id?: string;
  artifact_urls?: Record<string, Record<string, Record<string, string>>>;
};

export type AssistantJobCompletedTurnPayload = {
  chat_no: number;
  request: AssistantJobCompletedTurnRequest;
  response: AssistantJobCompletedTurnResponse;
};

export type AssistantJobCompletedEvent = {
  type: "job.completed";
  schema_version: 1;
  job_id: string;
  chat_id: string;
  chat_no?: number | null;
  trigger_chat_no?: number | null;
  model_id?: string | null;
  turn?: AssistantJobCompletedTurnPayload | null;
  trigger_turn?: AssistantJobCompletedTurnPayload | null;
};

export type AssistantJobErrorEvent = {
  type: "job.error";
  schema_version: 1;
  job_id: string;
  chat_id: string;
  chat_no?: number | null;
  trigger_chat_no?: number | null;
  model_id?: string | null;
};

export type AssistantSseEvent = AssistantJobCompletedEvent | AssistantJobErrorEvent;

export function parseAssistantSsePayload(raw: string): AssistantSseEvent | null {
  try {
    const parsed = JSON.parse(raw) as AssistantSseEvent;
    if (parsed.type === "job.completed" || parsed.type === "job.error") {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function hasJobCompletedTurnPayload(
  event: AssistantJobCompletedEvent,
): event is AssistantJobCompletedEvent & { turn: AssistantJobCompletedTurnPayload } {
  if (!event.turn || event.turn.chat_no <= 0) {
    return false;
  }
  const response = event.turn.response;
  if (!response) {
    return false;
  }
  return !!(
    response.output?.trim() ||
    Object.entries(response.figure ?? {}).some(
      ([key, value]) => key !== "artifact_urls" && value != null && Object.keys(value).length > 0,
    )
  );
}
